/* ============================================================
   data.ts — данные для BenefitsSection (страница /residents)
   Список преимуществ платформы для жителей ЖК
   ============================================================ */

import type { Benefit } from "./types.ts";
import {
    Wallet,
    Gauge,
    ClipboardList,
    MessageCircle,
    Vote,
    Bell,
} from "lucide-react";

/** Массив преимуществ платформы для жителей */
export const RESIDENT_BENEFITS: Benefit[] = [
    {
        icon: Wallet,
        title: "Оплата ЖКУ без комиссии",
        description:
            "Оплачивайте квитанции прямо в приложении. Никаких комиссий, очередей и сломанных терминалов.",
        badge: "Бесплатно",
    },
    {
        icon: Gauge,
        title: "Передача показаний",
        description:
            "Отправляйте показания счётчиков за пару секунд. История всегда под рукой.",
        badge: null,
    },
    {
        icon: ClipboardList,
        title: "Заявки 24/7",
        description:
            "Сломался кран? Нужен электрик? Подайте заявку в любое время — диспетчер увидит сразу.",
        badge: null,
    },
    {
        icon: MessageCircle,
        title: "Чат с УК и соседями",
        description:
            "Общайтесь с управляющей компанией и соседями напрямую. Групповые чаты по подъездам.",
        badge: null,
    },
    {
        icon: Vote,
        title: "Голосования",
        description:
            "Участвуйте в коллективных решениях: от ремонта крыши до нового шлагбаума.",
        badge: "Новое",
    },
    {
        icon: Bell,
        title: "Умные уведомления",
        description:
            "Напоминания о сроках оплаты, статус заявок, новости дома — ничего не упустите.",
        badge: null,
    },
];
